import gql from "../gql";
const LockedStamp = gql `
  fragment LockedStamp on StampLocked {
    __typename
    kind
    apiName
    name
    description
    eventDate
    eventLocation
    iconUrl
    linkUrl
  }
`;
export default gql `
  fragment LockedStamps on StampLockedConnection {
    __typename
    count
    totalCount
    edges {
      __typename
      cursor
      node {
        ...LockedStamp
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ${LockedStamp}
`;
